import styled, { css } from "styled-components";
import Notice from "../Notice";
import Modal from "./Modal";
import { DEFAULT_CHAIN_ID, FANTOM, SUPPORTED_CHAIN_IDS, getChainName } from "config/chains";
import { useCallback, useMemo } from "react";
import { clearWalletConnectData, clearWalletLinkData, switchNetwork } from "lib/wallets";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { CURRENT_PROVIDER_LOCALSTORAGE_KEY, SHOULD_EAGER_CONNECT_LOCALSTORAGE_KEY } from "config/localStorage";
import { WalletConnectConnectorV2 } from "lib/wallets/WalletConnectV2";

const WrongChainModal = () => {
  const { error, deactivate, chainId, connector } = useWeb3React();
  console.log(">> Check ~ WrongChainModal ~ connector:", connector instanceof WalletConnectConnectorV2);
  const disconnectAccount = useCallback(() => {
    // only works with WalletConnect
    clearWalletConnectData();
    // force clear localStorage connection for MM/CB Wallet (Brave legacy)
    clearWalletLinkData();
    deactivate();
  }, [deactivate]);

  const isWrongNetwork = useMemo(() => {
    if (error instanceof UnsupportedChainIdError || (chainId && !SUPPORTED_CHAIN_IDS.includes(chainId))) {
      return true;
    }
    return false;
  }, [error, chainId]);

  const disconnect = useCallback(() => {
    disconnectAccount();
    localStorage.removeItem(SHOULD_EAGER_CONNECT_LOCALSTORAGE_KEY);
    localStorage.removeItem(CURRENT_PROVIDER_LOCALSTORAGE_KEY);
  }, [disconnectAccount]);

  return (
    <>
      <Modal label="Check your network" isVisible={isWrongNetwork} setIsVisible={() => null}>
        <Text>
          Currently app only supported in {SUPPORTED_CHAIN_IDS.map((chainId) => getChainName(chainId)).join(", ")}
        </Text>
        <ActionWrapper>
          <Notice content="Please switch your network to continue" />
          {connector instanceof WalletConnectConnectorV2 ? (
            <ButtonConnect disabled>Can't switch here, please switch network in your wallet</ButtonConnect>
          ) : (
            <ButtonConnect onClick={() => switchNetwork(DEFAULT_CHAIN_ID, true)}>
              Switch network in wallet
            </ButtonConnect>
          )}
          <DisconnetButton onClick={() => disconnect()}>Disconnect Wallet</DisconnetButton>
        </ActionWrapper>
      </Modal>
    </>
  );
};

const ActionWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 16px;
`;

const ButtonConnect = styled.button<{ disabled?: boolean }>`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 12px;
  background: #34f5ae;
  border: none;
  outline: none;
  color: black;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  cursor: pointer;

  &:hover {
    opacity: 0.65;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`;

const DisconnetButton = styled(ButtonConnect)`
  border-radius: 12px;
  border: 1px solid #34f5ae;
  background-color: transparent;
  color: #34f5ae;
`;

const Text = styled.div`
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  margin-bottom: 24px;
`;

export default WrongChainModal;
